import * as React from "react";
import LoginPopup from "../generic/loginPopup";
import ChangePasswordForm, { IChPwFields } from "../forms/changePasswordForm";
import DeviceContext from "../../service/indentifyDevice";
import { ELoginPopupState, urls, EResetSubmitState } from "../loginConstants";
import "../../../assets/scss/components/login/loginScreen/loginScreen.scss";
import "../../../assets/scss/components/login/loginScreen/changePasswordScreen.scss";
import "../../../assets/scss/components/login/generic/loginFormBtmTxt.scss";
import { Link, RouteChildrenProps } from "react-router-dom";
import { AResetPassword } from "../../service/login/loginApiService";
import LoginService, { getAccData } from "../../service/login/loginService";
import LoginStatusScreen from "./loginStatusScreen";
import logo from "../../../assets/images/logo_white.jpg";

export interface IChangePasswordScreenProps {}

export interface IChangePasswordScreenState {
	errorMsg?: string;
	popupMessage?: string;
	submitState?: EResetSubmitState;
}

class ChangePasswordScreen extends React.Component<IChangePasswordScreenProps & RouteChildrenProps, IChangePasswordScreenState> {
	state: IChangePasswordScreenState = {};

	handleSubmit = ({ loginId, ...body }: IChPwFields) => {
		this.setState({ submitState: EResetSubmitState.ver_password });
		AResetPassword(this.changePasswordRes, getAccData("userID"), body);
	};

	changePasswordRes = (res: any) => {
		if (res.data && res.data.msg) {
			this.setState({ popupMessage: res.data.msg });
		} else {
			this.setState({ errorMsg: res.error.errMsg });
		}
	};

	onClose = () => {
		if (LoginService.reUrl) {
			this.redirect(LoginService.reUrl + (LoginService.params ? "&" + LoginService.params : ""));
		} else if (LoginService.fromUrl) {
			this.redirect(LoginService.fromUrl);
		} else {
			this.redirect(urls.home);
		}
	};

	redirect(url: string) {
		if (url.indexOf("http://") === 0 || url.indexOf("https://") === 0) {
			// If url is absolute
			window.location.href = url;
		} else {
			// if url is relative
			this.props.history.push(url);
		}
	}

	render() {
		return (
			<>
				<LoginPopup
					centerHeaderContent={
						DeviceContext().isDesktop ? <img src={logo} alt="nuvama" className="nuvama_logo"/> : <h1 className="title">Change Password</h1>
					}
					onClose={this.onClose}
					className="login_scrn change_pw_scrn"
				>
					{DeviceContext().isDesktop && (
						<div className="header">
							<h1 className="title">Change Password</h1>
						</div>
					)}

					<section className="login_form change_pw_form">
						<ChangePasswordForm
							onSubmit={this.handleSubmit}
							errorMsg={this.state.errorMsg}
							submitState={this.state.submitState}
							onRemoveError={() => this.setState({ errorMsg: undefined })}
						/>

						<div className="login_frm_btm_txt mg-t60">
							<p>
								<Link to="/login/help" className="link_btn">
									Login Help?
								</Link>
							</p>
						</div>
					</section>
				</LoginPopup>

				{this.state.popupMessage && (
					<LoginStatusScreen popupState={ELoginPopupState.RESET_SUCC} message={this.state.popupMessage} onLinkClick={this.onClose} />
				)}
			</>
		);
	}
}

export default ChangePasswordScreen;
